import React from "react";

const StepsSection = () => {
  const steps = [
    {
      id: 1,
      title: "Start Recording",
      description: (
        <>
          Click the <strong style={{ color: "#000000" }}>voice recorder</strong>
          . button. When asked, click Allow to give access to your
        </>
      ),
      image: "/img/stepsSection/recording.png",
      height: "130px",
      width: "130px",
      top: "25px",
    },
    {
      id: 2,
      title: "Speak & Stop",
      description:
        "Begin speaking to record your voice. Hit Stop when finished.",
      image: "/img/stepsSection/Frame 2608708.png",
      height: "102px",
      width: "295px",
      top: "38.75px",
    },
    {
      id: 3,
      title: "Save, Edit & Convert",
      description:
        "Save your recording to the cloud. Trim, merge, convert, transcribe, summarise or translate it with the AI tools.",
      image: "/img/stepsSection/Frame 2608710.png",
      height: "60px",
      width: "225px",
      top: "38.75px",
    },
  ];

  return (
    <div className="container py-5">
      <h2
        className="text-center mb-4"
        style={{
          fontFamily: "Metropolis",
          fontWeight: "700",
          fontSize: "34px",
        }}
      >
        How to Record Your Voice Online in 3 Easy Steps
      </h2>
      <div className="row justify-content-center">
        {steps.map((step, index) => (
          <div
            key={step.id}
            className="col-12 col-md-6 col-lg-4 d-flex flex-column align-items-stretch"
          >
            <div className="text-center p-3 mb-4 position-relative">
              <div className="card-body d-flex flex-column align-items-center">
                {/* Numbered Circle */}
                <div
                  className="mb-3 d-flex justify-content-center align-items-center border border-secondary rounded-circle bg-white"
                  style={{
                    height: "44px",
                    width: "44px",
                    color: "#334155",
                    fontWeight: "700",
                    zIndex: 2, // Ensures it's above other elements
                    position: "relative",
                  }}
                >
                  {index + 1}
                </div>

                {/* Title & Description */}
                <h5 className="fw-bold fs-5">{step.title}</h5>
                <p className="fw-medium fs-6 text-secondary">
                  {step.description}
                </p>
              </div>
            </div>

            {/* Image Container */}
            <div
              className="text-center position-relative"
              style={{ paddingTop: "10px" }}
            >
              <img
                src={step.image}
                alt={step.title}
                className="img-fluid"
                height={step?.height}
                width={step?.width}
                style={{
                  objectFit: "contain",
                  position: "relative",
                  top: "5px",
                  zIndex: 1,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepsSection;
